const req = require.context('../assets/icon', false, /\.svg$/)
req.keys().forEach(req)
